import { Navigate, useSearchParams } from 'react-router-dom'

export default function Register() {
  const [searchParams] = useSearchParams()

  const params = new URLSearchParams()
  const email = searchParams.get('email')
  const language = searchParams.get('language')
  if (email) params.set('email', email)
  if (language) params.set('language', language)
  params.set('aivy_form_source', 'discover')

  const qs = params.toString()
  return <Navigate to={qs ? `/funnel?${qs}` : '/funnel'} replace />
}
